
import template from './tv-status.vhtml';

export default {
	template,
	props: {
		allPartners: Array,
	},
	data() {
		return {
			partners: [],
		};
	},
	methods: {
		pollPartners() {
			// Shuffle array
			const shuffled = this.allPartners.sort(() => 0.5 - Math.random());

			// Get sub-array of first n elements after shuffled
			this.partners = shuffled.slice(0, 12);
		},

		pollClearPartners() {
			this.partners = [];
		},
	},

	mounted() {
		this.pollPartners();
		
		window.setInterval(() => {
			this.pollClearPartners();
			this.$nextTick(() => {
				this.pollPartners();
			});
		}, 12500);
	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/tv-status/tv-status.js